<template>
    <b-container fluid class="p-3">
        <h1><t icons.title /></h1>
        <b-button
            v-b-modal.single-modal
            @click="newIcon()">
            <t icons.new />
        </b-button>

        <b-modal
            id="single-modal"
            ref="single-modal"
            size="xl"
            hide-header
            hide-footer
            v-if="form"
            >
            <b-row>
            <b-col class="align-items-center">
                <svg v-if="form.visible" id="svg_icon" style="margin: 10%; width:80%" :viewBox="'' + form.xmin + ' ' + form.ymin + ' ' + form.xmax + ' ' + form.ymax">
                    <path :transform="form.transform" :d="form.path"></path>
                </svg>
                <svg v-else id="svg_icon" style="margin: 10%; width:80%">
                    <path :d="form.path"></path>
                </svg>
            </b-col>
            <b-col >
                <b-form  @submit="onSubmit" @reset="onReset">
                    <b-form-checkbox
                        class="mb-2"
                        id="input-active"
                        v-model="form.active"
                        switch
                        size="lg"
                        :value="true"
                        :unchecked-value="false"
                    >
                        <t icons.active v-if="form.active" />
                        <t icons.inactive v-else />
                    </b-form-checkbox>

                    <b-form-group
                        id="name-fieldset"
                        :label="$t('icons.name')"
                        label-for="name-input"
                        >

                        <b-form-input
                            id="name-input"
                            v-model="form.name"
                            required
                            >
                        </b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="svg-fieldset"
                        :description="$t('icons.svgpath')"
                        :label="$t('icons.svg')"
                        label-for="svg-input"
                        >

                        <b-form-textarea
                            id="svg-input"
                            v-model="form.path"
                            required
                            rows="5"
                            @change="onChange"
                            >
                        </b-form-textarea>
                    </b-form-group>

                    <b-form-group
                        id="categories-fieldset"
                        :label="$t('icons.category')"
                        label-for="categories-checkbox-group">
                        <b-form-checkbox-group
                            id="categories-checkbox-group"
                            v-model="form.categories"
                            :options="categoriesOptions"
                        ></b-form-checkbox-group>
                    </b-form-group>

                    <b-form-group
                        id="cuttable-fieldset"
                        :description="$t('fonts.cuttabledesc')"
                        :label="$t('fonts.cuttable')"
                        label-for="cuttable-input"
                        >

                        <b-form-checkbox
                            id="cuttable-input"
                            v-model="form.cuttable"
                            switch
                            :value="true"
                            :unchecked-value="false"
                        >
                        </b-form-checkbox>
                    </b-form-group>

                    <b-form-group
                        id="iscategory-fieldset"
                        :label="$t('fonts.iscategory')"
                        label-for="iscategory-input"
                        >

                        <b-form-checkbox
                            id="iscategory-input"
                            v-model="form.iscategory"
                            switch
                            :value="true"
                            :unchecked-value="false"
                        >
                        </b-form-checkbox>
                    </b-form-group>

                    <b-button type="submit" variant="primary" class="mr-2"><t common.save /></b-button>
                    <b-button type="reset" variant="danger"><t common.cancel /></b-button>
                </b-form>
            </b-col>
            </b-row>
        </b-modal>


        <b-button
            class="ml-3"
            v-b-modal.import-modal
            @click="newImport()">
            <t fonts.import />
        </b-button>

        <b-modal
            id="import-modal"
            ref="import-modal"
            size="xl"
            hide-header
            hide-footer
            v-if="form"
            >
            <b-row>
                <b-col class="importIcons">
                    <b-button-toolbar v-if="form.icons && form.icons.length > 0">
                        <b-button @click="selectAll()"><t icons.all /></b-button>
                        <b-button @click="selectNone()" class="ml-2"><t icons.none /></b-button>


                        <t icons.count /> : {{selectedIcons.length}}
                    </b-button-toolbar>
                    <b-button
                        variant="light"
                        class="icon"
                        :class="icon.selected ? 'selected' : ''"
                        @click="toggle(icon)"
                        v-for="icon in form.icons"
                        v-bind:key="icon.name">
                        <svg height="2em"
                            :viewBox="icon.xmin + ' ' + icon.ymin + ' ' + icon.xmax + ' ' + icon.ymax">
                            <path :transform="icon.transform" :d="icon.path"></path>
                        </svg>

                        <div class="text-center">{{icon.name}}</div>
                    </b-button>
                </b-col>
                <b-col>
                    <b-form @submit="onSubmitImport" @reset="onReset">
                        <b-form-group :label="$t('icons.importfile')" label-for="import-files">
                            <b-form-file
                                id='import-files'
                                ref='import-files'
                                accept=".svg"
                                v-model="form.files"
                                :placeholder="$t('icons.importdesc')"
                                multiple
                                @input="importFilesChanged()"
                                :browse-text="$t('common.select')">
                                <template slot="file-name" slot-scope="{ names }">
                                    <b-badge class='mr-1' variant="dark" v-for="name in names" v-bind:key="name">{{ name }}</b-badge>
                                </template>
                            </b-form-file>
                        </b-form-group>

                        <b-form-checkbox
                            class="mb-2"
                            id="input-active"
                            v-model="form.active"
                            switch
                            size="lg"
                            :value="true"
                            :unchecked-value="false"
                        >
                            <t icons.allactive v-if="form.active" />
                            <t icons.allinactive v-else />
                        </b-form-checkbox>

                        <b-form-group
                            id="categories-fieldset"
                            :label="$t('icons.category')"
                            label-for="categories-checkbox-group">
                            <b-form-checkbox-group
                                id="categories-checkbox-group"
                                v-model="form.categories"
                                :options="categoriesOptions"
                            ></b-form-checkbox-group>
                        </b-form-group>

                        <b-form-group
                            id="cuttable-fieldset"
                            :description="$t('fonts.cuttabledesc')"
                            :label="$t('fonts.cuttable')"
                            label-for="cuttable-input"
                            >

                            <b-form-checkbox
                                id="cuttable-input"
                                v-model="form.cuttable"
                                switch
                                :value="true"
                                :unchecked-value="false"
                            >
                            </b-form-checkbox>
                        </b-form-group>

                        <b-form-group
                            id="overwrite-fieldset"
                            :label="$t('fonts.overwrite')"
                            :description="$t('fonts.overwritedesc')"
                            label-for="overwrite-input"
                            >

                            <b-form-checkbox
                                id="overwrite-input"
                                v-model="form.overwrite"
                                switch
                                :value="true"
                                :unchecked-value="false"
                            >
                            </b-form-checkbox>
                        </b-form-group>

                        <b-button type="submit" variant="primary" class="mr-2"><t common.save /></b-button>
                        <b-button type="reset" variant="danger"><t common.cancel /></b-button>
                    </b-form>
                </b-col>
            </b-row>

        </b-modal>

        <b-container fluid class="p-3">
            <b-row>
                <b-col cols="2">
                    <h3><t icons.categories /></h3>
                    <b-button-group
                        v-for="category in categories"
                        v-bind:key="category.name"
                        class="m-2 d-flex">

                        <b-button
                            @click="selectedCategory = category.name"
                            variant="light" class="d-flex justify-content-between align-items-center">
                            <svg height="2em" :viewBox="category.xmin + ' ' + category.ymin + ' ' + category.xmax + ' ' + category.ymax">
                                <path :d="category.path"></path>
                            </svg>
                            {{category.name}}
                            <b-badge variant="primary" pill>{{category.count}}</b-badge>
                        </b-button>

                        <b-button
                            class="p-2"
                            v-b-modal.single-modal
                            @click="editIcon(category)">
                            <t icons.category.modify />
                        </b-button>
                    </b-button-group>
                </b-col>

                <b-col cols="10">
                    <h3><t icons.iconsincategory />{{selectedCategory}}</h3>
                    <div class="icons">
                        <b-button
                            variant="light"
                            class="icon"
                            v-b-modal.single-modal
                            @click="editIcon(icon)"
                            v-for="icon in iconsOfCategory"
                            v-bind:key="icon.name">
                            <svg :class="icon.active ? '' : 'disabled'" height="4em" :viewBox="icon.xmin + ' ' + icon.ymin + ' ' + icon.xmax + ' ' + icon.ymax">
                                <path :transform="icon.transform" :d="icon.path"></path>
                            </svg>

                            <div class="text-center">{{icon.name}}</div>
                        </b-button>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </b-container>
</template>

<script>

/* eslint-disable vue/no-unused-components */
import { BContainer, BButton, BModal, BFormGroup, BRow, BCol, BFormTextarea, BFormInput, VBModal, BButtonGroup, BBadge, BForm, BFormCheckbox, BFormCheckboxGroup, BFormFile, BButtonToolbar } from 'bootstrap-vue';
import { models } from 'feathers-vuex';

export default {
    components: { BContainer, BButton, BModal, BFormGroup, BRow, BCol, BFormTextarea, BFormInput, BButtonGroup, BBadge, BForm, BFormCheckbox, BFormCheckboxGroup, BFormFile, BButtonToolbar },
    directives: {'b-modal': VBModal },
    data() {
        return {
            icons: [],
            form: null,
            selectedCategory: null
        }
    },
    async mounted() {
        await this.refreshIcons();
        this.selectedCategory = 'all';
    },
    computed: {
        categories: function() {
            let counts = {};

            this.icons.filter(i => !i.iscategory)
            .forEach(icon => {
                icon.categories.forEach(cat => {
                    if(typeof counts[cat] == 'undefined') counts[cat] = 0;
                    counts[cat]++;
                })
            });

            let ret = this.icons.filter(i => i.iscategory);
            ret.forEach(cat => {
                cat.count = counts[cat.name] || 0;
            });

            return ret;
        },
        categoriesOptions: function() {
            return this.categories.map(cat => {
                return {
                    text: cat.name,
                    value: cat.name,
                    disabled: cat.name == 'all'
                }
            });
        },
        iconsOfCategory: function() {
            return this.icons.filter(i => !i.iscategory && i.categories.includes(this.selectedCategory))
        },
        selectedIcons: function() {
            return this.form.icons.filter(i => i.selected);
        }
    },
    methods: {
        newIcon() {
            this.selected = null;

            this.form = {
                path: '',
                categories: ['all'],
                name: '',
                xmin: 0,
                ymin: 0,
                xmax: null,
                ymax: null,
                active: true,
                cuttable: true,
                iscategory: false,
                visible : false,
            }
        },
        editIcon(icon) {
            this.selected = icon;

            this.form = {
                path: icon.path,
                categories: icon.categories,
                name: icon.name,
                xmin: icon.xmin || 0,
                ymin: icon.ymin || 0,
                xmax: icon.xmax || icon.width,
                ymax: icon.ymax || icon.height,
                active: icon.active,
                cuttable: icon.cuttable,
                iscategory: icon.iscategory,
                visible : true,
                transform : icon.transform
            }
        },
        newImport() {
            this.selected = null;

            this.form = {
                files: null,
                icons: [],
                categories: ['all'],
                overwrite: false,
                xmin: 0,
                ymin: 0,
                xmax: 1024,
                ymax: 1024,
                active: true,
                cuttable: true,
                iscategory: false
            }
        },

        async importFilesChanged() {
            let files = this.form.files;
            this.form.icons = [];
            files.forEach(async file => {
                let iconsOfFile = await this.importFile(file);
                this.form.icons = this.form.icons.concat(iconsOfFile);
            });
            this.icons.forEach(icon => icon.selected = true);
        },

        async importFile(file) {
            let icons = [];
            if (!file) return icons;

            const data = await new Response(file).text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(data, "application/xml");

            const symbols = doc.getElementsByTagName("symbol");

            if (symbols.length > 0) {
                for (let i = 0; i < symbols.length; i++) {
                    let symbol = symbols[i];
                    let [xmin, ymin, xmax, ymax] = symbol.getAttribute('viewBox').split(' ');

                    let path = '';
                    let paths = symbol.getElementsByTagName('path');
                    for (let i = 0; i < paths.length; i++ ) {
                        path += paths[i].getAttribute('d');
                    }

                    icons.push({
                        xmax: parseInt(xmax),
                        xmin: parseInt(xmin),
                        ymax: parseInt(ymax),
                        ymin: parseInt(ymin),
                        name: symbol.getAttribute('id'),
                        path,
                        selected: true
                    });
                }
                return icons;
            }

            const glyphs = doc.getElementsByTagName("glyph");

            if (glyphs.length > 0) {
                console.warn(this.$t('icons.onlysvg'))
                return icons;
            }

            const paths = doc.getElementsByTagName("path");

            let path = '';
            for (let i = 0; i < paths.length; i++ ) {
                path += paths[i].getAttribute('d');
            }
            let [xmin, ymin, xmax, ymax] = doc.firstElementChild.getAttribute('viewBox').split(' ');
            let transformValue;
            let transform = this.findTransformAttribute(doc.childNodes, transformValue);
            return [{
                xmax: parseInt(xmax),
                xmin: parseInt(xmin),
                ymax: parseInt(ymax),
                ymin: parseInt(ymin),
                name: file.name.substring(0,file.name.length - 4),
                path,
                selected: true,
                transform
            }]
        },

        findTransformAttribute(element, transformValue){
            element.forEach(e=>{
                if(e.getAttribute !== undefined){
                    if(e.getAttribute('transform') !== null){
                        transformValue = e.getAttribute('transform');
                    }
                }
                if(e.childNodes.length > 0){
                    transformValue = this.findTransformAttribute(e.childNodes, transformValue);
                }
            });
            return transformValue;
        },

        toggle(icon) {
            icon.selected = !icon.selected;
        },

        selectAll() {
            this.form.icons.forEach(icon => icon.selected = true);
        },

        selectNone() {
            this.form.icons.forEach(icon => icon.selected = false);
        },

        async refreshIcons() {
            let blockSize = 20;
            let response = await models.api.Icon.find({query: {$limit: blockSize}});
            this.icons = response.data;
            let steps = response.total / blockSize;

            for (let i = 1; i < steps; i++) {
                response = await models.api.Icon.find({query: {$limit: blockSize, $skip: i * blockSize}});
                this.icons = this.icons.concat(response.data);
            }

        },
        async onChange(){
            let iconSvg = document.querySelector("#svg_icon path");
            let svg = document.querySelector("#svg_icon");
            svg.removeAttribute("viewBox");
            this.form.xmax = iconSvg.getBoundingClientRect().width;
            this.form.ymax = iconSvg.getBoundingClientRect().height;
            this.form.xmin = (iconSvg.getBoundingClientRect().left - svg.getBoundingClientRect().left);
            this.form.ymin = (iconSvg.getBoundingClientRect().top - svg.getBoundingClientRect().top);
            this.form.visible = true;
        },
        async onSubmit(evt) {
            evt.preventDefault()
            try {
                if (this.selected == null) {
                    let icon = new models.api.Icon(this.form);
                    icon.create();
                } else {
                    this.selected.path = this.form.path;
                    this.selected.categories = this.form.categories;
                    this.selected.name = this.form.name;
                    this.selected.active = this.form.active;
                    this.selected.cuttable = this.form.cuttable;
                    this.selected.iscategory = this.form.iscategory;
                    this.selected.xmin = this.form.xmin ;
                    this.selected.ymin = this.form.ymin;
                    this.selected.xmax = this.form.xmax;
                    this.selected.ymax = this.form.ymax;

                    await this.selected.save();
                }
                this.$refs['single-modal'].hide()
                await this.refreshIcons();
            } catch (err) {
                console.error(err);
            }
        },

        async onSubmitImport(evt) {
            evt.preventDefault()
            try {
                for (let i = 0; i < this.selectedIcons.length; i++) {
                    let formIcon = this.selectedIcons[i];
                    formIcon.categories = this.form.categories;
                    formIcon.active = this.form.active;
                    formIcon.cuttable = this.form.cuttable;


                    let existingIcon = this.icons.find(icon => icon.name == formIcon.name);
                    if (existingIcon && this.form.overwrite) {

                        existingIcon.path = formIcon.path;
                        existingIcon.categories = formIcon.categories;
                        existingIcon.active = formIcon.active;
                        existingIcon.cuttable = formIcon.cuttable;
                        existingIcon.xmin = formIcon.xmin;
                        existingIcon.xmax = formIcon.xmax;
                        existingIcon.ymin = formIcon.ymin;
                        existingIcon.ymax = formIcon.ymax;

                        await existingIcon.save();
                    }
                    if (!existingIcon) {
                        let icon = new models.api.Icon(formIcon);
                        await icon.create();
                    }
                }
                this.$refs['import-modal'].hide();
                await this.refreshIcons();
            } catch (err) {
                console.error(err);
            }
        },
        async onReset(evt) {
            evt.preventDefault();
            await this.$refs['single-modal'].hide();
            await this.$refs['import-modal'].hide();
        }
    }
}
</script>

<style lang="scss" scoped>
    /* The sidebar menu */
    .icons {
        .icon {
            padding: 1em;
            background-color: #eee;
            margin: 0.5em;
            border: 2px solid #ddd;

        }
    }

    .importIcons {
        overflow-x: auto;
        max-height: 80vh;
        .icon {
            padding: 0.2em;
            background-color: #ddd;
            margin: 0.5em;
            border: 2px solid #ccc;
            display: inline-block;
            text-align: center;

            svg {
                fill: #555;
            }
        }

        .icon.selected {
            background-color: #f2f2f2;
            border: 2px solid orange;

            svg {
                fill: #111;
            }
        }
    }

    svg.disabled {
        fill: #bbb;
    }
</style>
